import type { SVGProps } from 'react';

export function IconArrowRight(props: SVGProps<SVGSVGElement>) {
    return (
        <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M18.1436 7.47011C18.4365 7.1774 18.9113 7.17716 19.2041 7.47011L27.1689 15.4408C27.1944 15.4638 27.2172 15.4888 27.2393 15.515C27.2459 15.5228 27.2525 15.5305 27.2588 15.5385C27.3571 15.6653 27.418 15.8226 27.418 15.9955C27.418 16.0426 27.4126 16.0885 27.4043 16.1332C27.3781 16.2785 27.3105 16.4183 27.1982 16.5307L19.2041 24.5307C18.9113 24.8232 18.4364 24.8232 18.1436 24.5307C17.8507 24.238 17.8502 23.7631 18.1426 23.4701L24.8633 16.7455H5.33301C4.91899 16.7453 4.58304 16.4096 4.58301 15.9955C4.58301 15.5814 4.91897 15.2457 5.33301 15.2455H24.8535L18.1426 8.53066C17.85 8.2378 17.851 7.76292 18.1436 7.47011Z"
                fill="currentColor"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
}
